import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Menu,
  MenuItem,
  Paper,
} from "@mui/material";
import FilterIcon from "@mui/icons-material/Tune";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircleLoader } from "react-spinners";
import { productDeleteRequest } from "../../../redux/products/ProductAction";
import { consumptionViewAllRequest } from "../../../redux/reports/ReportAction";
import { getColumnWidth } from "../../../style/datagridMQ";
import { StyledContainer } from "../../components/style";
import CustomDataGrid from "../../constant/commondatagrid";
import Pagination from "../../constant/CommonPagenation";
import { filterStyles } from "../../components/LoginStyles";

const columns = (handleDeleteRow) => [
  {
    field: "ShotsNo",
    headerName: "Shots No",
    width: getColumnWidth("column"),
    renderCell: (params) => params.value || "No Shots No",
  },
  {
    field: "CustomerName",
    headerName: "Customer Name",
    width: getColumnWidth("column"),
    renderCell: (params) => params.value || "No Customer Name",
  },
  {
    field: "CustomerPhone",
    headerName: "Mobile No",
    width: getColumnWidth("column"),
    renderCell: (params) => params.value || "No Mobile No",
  },
  {
    field: "BarName",
    headerName: "Bar Name",
    width: getColumnWidth("column"),
    renderCell: (params) => params.value || "No Bar Name",
  },
  {
    field: "ProductName",
    headerName: "Sub Brand Name",
    width: getColumnWidth("column"),
    renderCell: (params) => params.value || "No Product Name",
  },
  {
    field: "TotalShots",
    headerName: "No Of Shots",
    width: getColumnWidth("column"),
    renderCell: (params) => params.value || "0",
  },
  {
    field: "UpdatedDate",
    headerName: "Used Date",
    width: getColumnWidth("column"),
    renderCell: (params) => params.value || "No Date Available",
  },
  {
    field: "ConsumedShots",
    headerName: "Used Shots",
    width: getColumnWidth("column"),
    renderCell: (params) => params.value || "0",
  },
  {
    field: "AvailableShots",
    headerName: "Available Shots",
    width: getColumnWidth("column"),
    renderCell: (params) => params.value || "0",
  },
];

const ConsumedList = () => {
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [emptyList, setEmptyList] = useState([]);
  //search
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();
  const viewAllConsumptionShot = useSelector(
    (state) => state?.consumption?.viewAllConsumptionShots || {}
  );
  const WholesalerId = useSelector(
    (state) => state?.values?.loginValues?.[0]?.wholesaler_id
  );
  const ConsumptionList = viewAllConsumptionShot?.data?.data || [];
  const totalRecords = viewAllConsumptionShot?.data?.totalRecords || 0;
  const productPageSize = viewAllConsumptionShot?.pageSize || 10;

  //shots list records
  const responseArray = viewAllConsumptionShot?.data?.data || [];
  const totalShotsInResponse = responseArray[0]?.totalShotsInResponse || 0;

  const preprocessData = (data) => {
    const processedRows = [];

    data.forEach((wholesaler) => {
      wholesaler.Bars?.forEach((bar) => {
        bar.Shots?.forEach((shot) => {
          const customer = shot.Customer || {};

          const totalOrderShots = shot.totalOrderShots || 0;
          const currentShotQty = parseInt(shot.qty) || 0;

          processedRows.push({
            id: shot.id,
            WholesalerName: wholesaler.wholesaler_name,

            ShotsNo: shot.shots_no || "N/A",
            ProductName: shot.product_name || "N/A",
            TotalShots: totalOrderShots,
            ConsumedShots: currentShotQty,
            AvailableShots: Math.max(0, totalOrderShots - currentShotQty),

            CustomerName: `${customer.first_name || "N/A"} ${
              customer.last_name || ""
            }`.trim(),
            CustomerEmail: customer.email || "N/A",
            CustomerPhone: customer.phone || "N/A",

            BarName: bar.name || "N/A",

            DeliveredAt: shot.delivered_at
              ? new Date(shot.delivered_at).toLocaleDateString()
              : "N/A",
            UpdatedDate: shot.created_at
              ? shot.created_at.split("T")[0]
              : "N/A",
            CreatedDate: shot.created_at || "N/A",

            OrderId: shot.order_id || "N/A",
            Status: shot.status || 0,
            Quantity: shot.qty || "0",

            BrandName: shot.brand_name || "N/A",
            AlcoholPercentage: "N/A",
            TypeOfAlcohol: shot.type_of_alcohol || "N/A",
            Price: "N/A",
            ProductImage: "N/A",
          });
        });
      });
    });

    return processedRows;
  };

  // useEffect(() => {
  //   dispatch(consumptionViewAllRequest(WholesalerId, currentPage, searchTerm));
  // }, [WholesalerId, currentPage]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      dispatch(
        consumptionViewAllRequest(WholesalerId, currentPage, searchTerm)
      );
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [searchTerm, currentPage, WholesalerId, dispatch]);

  useEffect(() => {
    if (viewAllConsumptionShot?.success && ConsumptionList.length > 0) {
      const processedData = preprocessData(ConsumptionList);
      setRows(processedData);
    } else {
      setRows(emptyList);
    }
  }, [ConsumptionList, viewAllConsumptionShot]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleDeleteRow = (id) => {
    setProductToDelete(id);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    dispatch(productDeleteRequest(productToDelete));
    setRows((prevRows) =>
      prevRows.filter((row) => row?.id !== productToDelete)
    );
    setProductToDelete(null);
    setOpenDialog(false);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Bar Name Asc":
        sortedRows.sort((a, b) => a?.BarName?.localeCompare(b?.BarName));
        break;
      case "Sort by Bar Name Desc":
        sortedRows.sort((a, b) => b?.BarName?.localeCompare(a?.BarName));
        break;
      case "Sort by Product Name Asc":
        sortedRows.sort((a, b) =>
          a?.ProductName?.localeCompare(b?.ProductName)
        );
        break;
      case "Sort by Product Name Desc":
        sortedRows.sort((a, b) =>
          b?.ProductName?.localeCompare(a?.ProductName)
        );
        break;
      case "Sort by Used Date Asc":
        sortedRows.sort(
          (a, b) => new Date(a?.UpdatedDate) - new Date(b?.UpdatedDate)
        );
        break;
      case "Sort by Used Date Desc":
        sortedRows.sort(
          (a, b) => new Date(b?.UpdatedDate) - new Date(a?.UpdatedDate)
        );
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  const totalPages = Math.ceil(totalRecords / productPageSize);

  return (
    <>
      <Grid container spacing={2} pl={6}>
        <Grid item xs={12} sm={12} md={7} lg={8} xl={10}>
          <Box className="headingTable">
            <h1>Consumption Insights</h1>
            <p>Here is your general consumption shots list data</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={4} xl={2}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>
      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Bar Name Asc")}
          >
            Bar Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Bar Name Desc")}
          >
            Bar Name Z-A
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Product Name Asc")}
          >
            Product Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Product Name Desc")}
          >
            Product Name Z-A
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Used Date Asc")}
          >
            Used Date (Oldest First)
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Used Date Desc")}
          >
            Used Date (Newest First)
          </MenuItem>
        </Menu>

        <Paper>
          {/*search*/}
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <input
              type="text"
              // placeholder="Search by sub-brand name"
              placeholder="Search by customer/bar name, email, mobile"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "300px",
              }}
            />
          </Box>
          <Box>
            {viewAllConsumptionShot?.inProgress && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(255, 255, 255, 0.5)"
                zIndex={1000}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircleLoader
                    loading={viewAllConsumptionShot?.inProgress}
                    size={50}
                    color="#0458d3"
                  />
                </Box>
              </Box>
            )}
            {/* {viewAllConsumptionShot?.success && ( */}
            <CustomDataGrid
              rows={rows}
              columns={columns(handleDeleteRow)}
              pageSize={productPageSize}
              pagination={true}
              rowHeight={70}
              getRowId={(row) => row.id || `fallback-${Math.random()}`}
              onSelectionModelChange={(newSelection) => {
                setSelection(newSelection);
              }}
              sx={filterStyles.modalHeight(rows)}
            />
            {/* )} */}
          </Box>
        </Paper>
        <Box mt={2}>
          {viewAllConsumptionShot?.success && (
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRecords={totalShotsInResponse}
              pageSize={productPageSize}
            />
          )}
        </Box>
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this row?
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDialog(false)}
              sx={{
                backgroundColor: "rgb(189, 189, 191)",
                color: "rgb(252, 249, 249)",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={confirmDelete}
              sx={{ backgroundColor: "rgb(0,55,255)", color: "#fff" }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </StyledContainer>
    </>
  );
};

export default ConsumedList;
